import { Outlet, Link, useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { BookOpen, Trophy, User, Settings, LogOut } from 'lucide-react'
import { UserAvatar } from '@/components/Avatar'

export default function Layout() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 只在用户已登录时显示导航栏 */}
      {user && (
        <nav className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="px-4">
          {/* Logo行 */}
          <div className="flex justify-between items-center h-14 border-b border-gray-100">
            <Link to="/" className="flex items-center space-x-2">
              <BookOpen className="h-6 w-6 text-primary-600" />
              <span className="text-lg font-bold text-gray-900">读书榜</span>
            </Link>

            {/* 右侧用户信息 */}
            <div className="flex items-center space-x-3">
              <Link to="/profile" className="flex items-center space-x-2">
                <UserAvatar
                  src={user.avatar}
                  username={user.username}
                  userId={user.id}
                  size="sm"
                  className="border-2 border-gray-200"
                  priority={true}
                  lazy={false}
                />
                <span className="text-sm font-medium text-gray-700 max-w-[80px] truncate">
                  {user.username}
                </span>
              </Link>

              <button
                onClick={handleLogout}
                className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </div>
          </div>

          {/* 导航菜单行 */}
          <div className="flex justify-center py-3">
            <div className="flex space-x-1 bg-gray-100 rounded-lg p-1">
              <Link
                to="/"
                className="flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-white transition-colors"
              >
                <BookOpen className="h-4 w-4" />
                <span>首页</span>
              </Link>

              <Link
                to="/leaderboard"
                className="flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-white transition-colors"
              >
                <Trophy className="h-4 w-4" />
                <span>排行榜</span>
              </Link>

              <Link
                to="/profile"
                className="flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-white transition-colors"
              >
                <User className="h-4 w-4" />
                <span>个人</span>
              </Link>

              {user.isAdmin && (
                <Link
                  to="/admin"
                  className="flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 hover:bg-white transition-colors"
                >
                  <Settings className="h-4 w-4" />
                  <span>管理</span>
                </Link>
              )}
            </div>
          </div>
        </div>
        </nav>
      )}

      <main>
        <Outlet />
      </main>
    </div>
  )
}
